import { Component } from '@mycolorway/tao';
import request from 'next/javascripts/modules/request';
import createPusher from 'next/javascripts/modules/pusher/create';

Component('tr-edit-status', {
  properties: {
    channelId: String,
    editStatusUrl: String,
  },

  connected() {
    if (!this.channelId) return;
    this.pusher = createPusher();
    this.subscribeChannel();
    this.fetchCurrentStatus();
  },

  subscribeChannel() {
    this.pusher.subscribe(this.channelId)
      .bind('edit_status_changed', (data) => {
        if (data.success) this.updateStatus(data.current_editors);
      });
  },

  fetchCurrentStatus() {
    if (!this.editStatusUrl) return;

    this.requestXHR = request({
      url: this.editStatusUrl,
      type: 'get',
      dataType: 'json',
      success: (data) => {
        if (data.success) this.updateStatus(data.current_editors);
      },
      complete: () => {
        this.requestXHR = null;
      },
    }, ({ content }) => {
      if (content.success) this.updateStatus(content.current_editors);
    });
  },

  updateStatus(currentEditors) {
    if (currentEditors && currentEditors.length) {
      if (window.tower.me) {
        const index = Array.from(currentEditors.map(editor => editor.guid))
          .indexOf(window.tower.me.guid);
        if (index > -1) currentEditors.splice(index, 1);
      }

      if (currentEditors.length) {
        const currentEditorNames = Array.from(currentEditors.map(editor => editor.name));
        let names;
        if (currentEditorNames.length > 3) {
          names = `${currentEditorNames.slice(0, 3).join('、')} 等 ${currentEditorNames.length} 人`;
        } else {
          names = `${currentEditorNames.join('、')} `;
        }
        this.innerHTML = `(${names}正在编辑)`;
        return;
      }
    }

    this.innerHTML = '';
  },

  disconnected() {
    if (this.requestXHR) this.requestXHR.abort();
    if (this.pusher) this.pusher.unsubscribe(this.channelId);
  },
});
